import React from 'react';
import moment from 'moment';

import {
  SelectField,
  TextAreaField,
  TextField,
  MCButton,
  AutoCompleteField,
  Spinner,
  RadiosField
} from 'src/components/basic';
import { DateSelects } from 'src/components/complex';
import SVGIcon from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { remCss, lang, withRouter, userFullName } from 'src/helpers';

import model from './model';
import AddAdvance from './Advance';

class AddPatient extends BaseComponent {
  apiStateId = 'invite';
  componentDidMount() {
    model.subscribe(this.subscription);
    const id = this.props.router.params.id;
    model.reset();
    if (id) {
      model.getDetail(parseInt(id), (err, data) => {
        if (err) {
          this.navigate('/admin/clients');
        } else {
          model.setState({
            patient: data,
            fullname: userFullName(data),
            selectedSlot: null,
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            gender: data.gender || '',
            birthday: data.birthday || '',
            countryAddress: data.countryAddress || '',
            stateAddress: data.stateAddress || '',
            cityAddress: data.cityAddress || '',
            phoneNumber: data.phoneNumber || '',
            email: data.email || '',
            address: data.address || '',
            zipcode: data.zipcode || '',
            clinicId: data.invitation?.clinicId || null,
            doctorId: data.invitation?.doctorId || null
          });
        }
      });
    } else {
      this.navigate('/admin/clients');
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  add = (event) => {
    event.preventDefault();

    model.sendInvite(this.props.router.params.id, (err, data, success) => {
      if (success) {
        this.back();
      }
    });
  };

  back = () => {
    this.navigate('/admin/clients');
  };

  renderRow = (row, i) => {
    const createState = model.getApiState(this.apiStateId);
    const { invalid } = createState;

    return (
      <div className={'mc-flex mc-form-row'} key={`row-${i}`}>
        {row.map((itemCol, j) => (
          <div className={'mc-flex-col mc-grow'} key={`col-${i}-${j}`}>
            <div>{lang.t(itemCol.label)}</div>
            {itemCol.type === 'input' && (
              <TextField
                template={6}
                name={itemCol.name}
                placeholder={itemCol.placeholder}
                value={model.input(itemCol.name)}
                onChange={(n, v) => {
                  model.resetApiState(this.apiStateId);
                  model.handleChange(n, v);
                }}
                onBlur={model.handleBlur}
                invalid={invalid}
              />
            )}
            {itemCol.type === 'phone' && (
              <TextField
                template={6}
                name={itemCol.name}
                type={'phone'}
                defaultCountryName={model.state.tempCountryAddress}
                placeholder={itemCol.placeholder}
                value={model.input(itemCol.name)}
                onChange={(n, v) => {
                  model.resetApiState(this.apiStateId);
                  model.handleChange(n, v);
                }}
                onBlur={model.handleBlur}
                invalid={invalid}
              />
            )}
            {itemCol.type === 'areainput' && (
              <TextAreaField
                template={5}
                name={itemCol.name}
                placeholder={itemCol.placeholder}
                value={model.input(itemCol.name)}
                onChange={(n, v) => {
                  model.resetApiState(this.apiStateId);
                  model.handleChange(n, v);
                }}
                onBlur={model.handleBlur}
                invalid={invalid}
                rows={2}
              />
            )}
            {itemCol.type === 'select' && (
              <SelectField
                template={5}
                name={itemCol.name}
                placeholder={itemCol.placeholder}
                value={model.input(itemCol.name)}
                disabled={itemCol.disabled}
                onChange={(n, v) => {
                  if (v !== model.input(n)) {
                    model.resetApiState(this.apiStateId);
                    model.handleChange(n, v);
                    if (n === 'countryAddress') {
                      model.handleChange('cityAddress', '');
                    }
                  }
                }}
                width={'100%'}
                options={itemCol.options}
                invalid={invalid}
              />
            )}
            {itemCol.type === 'birthday' && (
              <>
                <DateSelects
                  template={5}
                  onChange={(n, v) => {
                    model.resetApiState(this.apiStateId);
                    model.handleChange(n, v);
                  }}
                  className={'mc-flex-20'}
                  minDate={moment().startOf('year').year(1900)}
                  maxDate={moment().add({ years: -14 }).endOf('year')}
                  invalid={invalid}
                  name={'birthday'}
                  date={model.input('birthday')}
                />

                {invalid['birthday'] && (
                  <p className='mc-form-invalid-text'>{invalid['birthday']}</p>
                )}
              </>
            )}
            {itemCol.type === 'autocomplete' && (
              <>
                <AutoCompleteField
                  template={5}
                  name={itemCol.name}
                  value={model.input(itemCol.name)}
                  onChange={(n, v) => {
                    model.resetApiState(this.apiStateId);
                    model.handleChange(n, v);
                    if (n === 'countryAddress') {
                      model.handleChange('stateAddress', '');
                    }
                    if (['countryAddress', 'stateAddress'].indexOf(n) > -1) {
                      model.handleChange('cityAddress', '');
                    }
                  }}
                  {...itemCol.props}
                />

                {invalid[itemCol.name] && (
                  <p className='mc-form-invalid-text'>{invalid[itemCol.name]}</p>
                )}
              </>
            )}
            {itemCol.type === 'clinic' && model.state.user?.isDoctor && (
              <>
                <div>{lang.t('Clinic')}</div>
                {model.state.clinicLoading ? (
                  <Spinner />
                ) : (
                  <div className={'mc-flex-20 mc-wrap'}>
                    <RadiosField
                      template={'2'}
                      shape={''}
                      list={[{ value: null, label: 'Independent' }, ...model.state.clinics]}
                      data={model.input('clinicId')}
                      onChange={(v) => {
                        model.resetApiState(this.apiStateId);
                        model.handleChange('clinicId', v);
                      }}
                    />
                  </div>
                )}
                {invalid['clinicId'] && (
                  <p className='mc-form-invalid-text'>{invalid['clinicId']}</p>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    );
  };

  render() {
    const createState = model.getApiState(this.apiStateId);
    const isReady = !!model.state.patient;

    return (
      <div className={'mc-container-content mc-add-patient'}>
        <div className={'mc-container-content__header mc-flex'}>
          <div className={'mc-no-style-btn'} style={{ height: remCss(40) }} onClick={this.back}>
            <SVGIcon width={40} iconname={'back-icon'} />
          </div>
          <span className={'mc-grow'}>
            {lang.t('Edit patient') + ': '}
            {isReady && userFullName(model.state.patient)}
          </span>
        </div>
        <div className={'mc-container-content__body'}>
          <div className={'mc-container-content__body-content border'}>
            <div className={'mc-tab-box-opacity'}>
              {isReady && <AddAdvance renderRow={this.renderRow} apiStateId={this.apiStateId} />}
            </div>
          </div>
          <div className={'mc-container-content__body-footer'}>
            <div className={'mc-flex'}>
              <div className={'mc-grow'}></div>
              <MCButton
                primary
                dark
                radius
                medium
                disabled={createState.loading}
                onClick={this.add}
              >
                {createState.loading ? lang.t('Saving') + '...' : lang.t('Save')}
              </MCButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AddPatient);
